/* ===========================================================================
   MAVELY ETSY  v1   (MV124)  \u2014  an ETSY button in the Deals List store row
   ===========================================================================
   Adds one ETSY button beside WALMART / AMAZON / ALIEXPRESS / OTHER (before
   OTHER) in the Deals List and in the Manual Deal List, and drives the SAME
   React state those buttons drive (the list's store state). The app itself
   then asks /api/deals?store=etsy&source=deals and shows its own "Show All",
   count, pages, sorts and categories exactly as for any other store.
   The server lists a deal under ETSY when its store is 'etsy' or when it is
   an older deal stored as 'other' whose link is an Etsy link
   (api/_deals_lib.php: deals_effective_store).

   Nothing React made is moved or removed; one button is inserted. If a later
   build of the app no longer exposes the list's store state, the button
   hides itself (it never shows a button that does nothing).

   Speed: only buttons carrying the store buttons' own classes are looked at,
   a whole-page look happens at most every 300 ms, and each store row has
   its own small observer for its highlight.

   Console: __mvEtsy()
   =========================================================================== */
(function () {
  'use strict';
  if (window.__mvEtsyLoaded) return;
  window.__mvEtsyLoaded = true;

  var WORDS = { walmart: 1, amazon: 1, aliexpress: 1, other: 1, '\u0623\u062e\u0631\u0649': 1 };
  var STATE_RE = /^(all|walmart|amazon|aliexpress|other|etsy)$/i;
  var stats = { rows: 0, clicks: 0, noHook: 0 };

  function addCss() {
    if (document.getElementById('mv-etsy-css')) return;
    var s = document.createElement('style');
    s.id = 'mv-etsy-css';
    s.textContent =
      'button.mv-etsy-btn{background:rgba(234,88,12,.9);color:#fff;--tw-ring-color:#fdba74}' +
      'button.mv-etsy-btn:hover{background:#ea580c}' +
      'button.mv-etsy-btn.ring-2{background:#ea580c;--tw-shadow:0 4px 6px -1px rgba(124,45,18,.5)}' +
      'html[data-mv-rd] .mv-rd-dl button[class*="font-black uppercase tracking-wider"].mv-etsy-btn{background:rgba(245,100,0,.14)!important;color:#ff9b52!important;border-color:rgba(245,100,0,.38)!important}' +
      'html[data-mv-rd] .mv-rd-dl button[class*="font-black uppercase tracking-wider"].mv-etsy-btn.ring-2{background:#f56400!important;color:#fff!important;border-color:#f56400!important}' +
      'html[data-mv-rd][data-mv-theme="light"] .mv-rd-dl button[class*="font-black uppercase tracking-wider"].mv-etsy-btn:not(.ring-2){color:#c24e00!important}';
    (document.head || document.documentElement).appendChild(s);
  }

  /* Store rows: a parent holding >= 3 buttons whose own text is a store name. */
  function rows() {
    var bs = document.querySelectorAll('button[class*="tracking-wider"][class*="font-black"]'), seen = [], n = [];
    for (var i = 0; i < bs.length; i++) {
      if (bs[i].classList.contains('mv-etsy-btn')) continue;
      var t = (bs[i].textContent || '').trim().toLowerCase();
      if (!WORDS[t]) continue;
      var p = bs[i].parentElement, at = seen.indexOf(p);
      if (at === -1) { seen.push(p); n.push(1); } else n[at]++;
    }
    var out = [];
    for (var j = 0; j < seen.length; j++) if (n[j] >= 3) out.push(seen[j]);
    return out;
  }
  function storeButtons(row) {
    var out = [];
    for (var i = 0; i < row.children.length; i++) {
      var b = row.children[i];
      if (b.tagName === 'BUTTON' && !b.classList.contains('mv-etsy-btn') && WORDS[(b.textContent || '').trim().toLowerCase()]) out.push(b);
    }
    return out;
  }

  /* The list component's store state: the first useState hook (of the
     component that rendered the button) whose value is a store name. */
  function hookOf(row) {
    var b = storeButtons(row)[0];
    if (!b) return null;
    var key = null;
    for (var k in b) if (k.indexOf('__reactFiber$') === 0) { key = k; break; }
    var f = key ? b[key] : null;
    for (var d = 0; f && d < 25; d++, f = f.return) {
      if (typeof f.type !== 'function') continue;
      for (var h = f.memoizedState, i = 0; h && i < 60; h = h.next, i++) {
        var q = h.queue;
        if (q && typeof q.dispatch === 'function' && typeof q.lastRenderedState === 'string' && STATE_RE.test(q.lastRenderedState)) {
          var upper = /^[A-Z]+$/.test(q.lastRenderedState);
          return { q: q, etsy: upper ? 'ETSY' : 'etsy', all: upper ? 'ALL' : 'all' };
        }
      }
      return null;              // only the component that rendered the row
    }
    return null;
  }

  var BASE = 'px-3 py-1 rounded-lg text-xs font-black uppercase tracking-wider transition-all cursor-pointer whitespace-nowrap mv-etsy-btn';
  function paint(row) {
    var btn = row.querySelector(':scope > .mv-etsy-btn');
    var hk = hookOf(row);
    if (!hk) { if (btn) btn.style.display = 'none'; stats.noHook++; return; }
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = 'Etsy';
      btn.title = 'Etsy deals';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var h = hookOf(row);
        if (!h) return;
        stats.clicks++;
        h.q.dispatch(h.q.lastRenderedState === h.etsy ? h.all : h.etsy);
        setTimeout(function () { paint(row); }, 0);
      });
      var sb = storeButtons(row), other = null;
      for (var i = 0; i < sb.length; i++) if (/^(other|\u0623\u062e\u0631\u0649)$/i.test(sb[i].textContent.trim())) other = sb[i];
      row.insertBefore(btn, other || (sb.length ? sb[sb.length - 1].nextSibling : null));
      stats.rows++;
    }
    btn.style.display = '';
    var on = hk.q.lastRenderedState === hk.etsy;
    var cls = BASE + (on ? ' ring-2 shadow-md' : '');
    if (btn.className !== cls) btn.className = cls;
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  var pending = 0, lastScan = 0;
  function scan() {
    pending = 0;
    lastScan = Date.now();
    var rs = rows();
    for (var i = 0; i < rs.length; i++) {
      try { paint(rs[i]); } catch (e) {}
      if (!rs[i].__mvEtsyObs) {
        rs[i].__mvEtsyObs = true;
        (function (row) {
          new MutationObserver(function () { schedule(); })
            .observe(row, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
        })(rs[i]);
      }
    }
  }
  function schedule() {
    if (pending) return;
    pending = setTimeout(scan, Math.max(30, 300 - (Date.now() - lastScan)));
  }

  function start() {
    if (!document.body) { setTimeout(start, 50); return; }
    addCss();
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) if (ms[i].addedNodes && ms[i].addedNodes.length) { schedule(); return; }
    }).observe(document.body, { childList: true, subtree: true });
    scan();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  window.__mvEtsy = function () {
    var rs = rows(), info = [];
    for (var i = 0; i < rs.length; i++) { var h = hookOf(rs[i]); info.push({ state: h ? h.q.lastRenderedState : '(no hook)', hasButton: !!rs[i].querySelector('.mv-etsy-btn') }); }
    return { version: 1, rows: info, stats: stats };
  };
})();
